"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _api = require("@lce/api");

var _TreasureData = _interopRequireWildcard(require("../TreasureData"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var editAccount = function editAccount(_a) {
  var accountId = _a.accountId,
      firstName = _a.firstName,
      lastName = _a.lastName,
      phoneNumber = _a.phoneNumber,
      marketingOptIn = _a.marketingOptIn;

  if (_TreasureData["default"].inSignedMode()) {
    _TreasureData["default"].trackEvent(_TreasureData.EventTypes.Website, {
      eventName: _TreasureData.Events.EditAccount,
      firstName: firstName,
      lastName: lastName,
      phoneNumber: phoneNumber,
      marketingOptIn: marketingOptIn,
      deviceUniqueId: (0, _api.getFingerprint)(),
      userAccountId: accountId
    });
  }
};

var _default = editAccount;
exports["default"] = _default;